import { DataTable } from '../components/DataTable.tsx';
import { EmptyState, ErrorState, LoadingState, StatusChip } from '../components/FdPrimitives.tsx';
import { useFetch } from '../hooks/useFetch.ts';

type WebhookSubscription = {
  subscription_id: string;
  url: string;
  enabled: boolean;
  event_types: string[];
};

export function WebhooksPage() {
  const state = useFetch<{ subscriptions: WebhookSubscription[]; wired: boolean }>('/webhooks');

  if (state.status === 'loading') return <LoadingState label="Loading webhooks" />;
  if (state.status === 'error') return <ErrorState message={state.message} />;
  if (!state.data.wired) {
    return <EmptyState icon="webhook" title="Webhook store not wired" message="Subscriptions will appear after the webhook store is configured." />;
  }

  return (
    <div className="page-stack">
      <DataTable
        title="Webhooks"
        icon="webhook"
        rows={state.data.subscriptions}
        emptyTitle="No webhook subscriptions"
        emptyMessage="Configured delivery endpoints will appear here."
        columns={[
          { key: 'subscription_id', header: 'ID', className: 'cid' },
          { key: 'url', header: 'URL' },
          {
            key: 'enabled',
            header: 'Status',
            render: (subscription) => <StatusChip value={subscription.enabled ? 'active' : 'disabled'} />,
          },
          {
            key: 'event_types',
            header: 'Events',
            render: (subscription) => subscription.event_types.join(', '),
          },
        ]}
      />
    </div>
  );
}
